module.exports = __webpack_public_path__ + "img/check-gray.aef7fead.svg";